import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import makeRequest from "../../../utils/makeRequest";
import * as urls from "../../../utils/URLConst";
import toastNotify from "../../../utils/ToastNotify";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import SelectField from "../../textField/SelectField";
import { handleLoader } from "../../../redux/reducers/layout";
import TextField from "../../textField/TextField";

const ClientcontactDtlAddModal = ({
  isOpen,
  handleAddCustUserMdl,
  fetchCustomersUsers,
  editData
}) => {

  const isEdit = editData;
  const dispatch = useDispatch();

  const [designationList, setDesignationList] = useState([]);

  const fetchDesignation = async () => {
    try {
      dispatch(handleLoader(true));
      const data = {};
      const config = {};

      await makeRequest("POST", urls.setDesignation, data, config).then(
        (result) => {
          if (result.STATUS === "0") {
            const response = result.RESPONSE;
            setDesignationList(response);
          } else if (result.STATUS !== "0") {
          }
        }
      );
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  };

  useEffect(() => {
    fetchDesignation();
  }, []);

  async function addCustomer(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        DESIGNATION_CD: val.designationValue,
        PERSON_NM: val.personNm,
        MOBILE_NO1: val.contactNo,
        MOBILE_NO2: "",
        EMAIL: val.emailId,
        STATUS: "",
        ACTION_FLAG: "A",
      };

      const result = await makeRequest(
        "POST",
        urls.setUserContactDtl,
        payload,
        config
      );

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        fetchCustomersUsers();
        handleAddCustUserMdl();
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function updateCustomer(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        TRAN_CD: editData.TRAN_CD,
        DESIGNATION_CD: val.designationValue,
        PERSON_NM: val.personNm,
        MOBILE_NO1: val.contactNo,
        MOBILE_NO2: "",
        EMAIL: val.emailId,
        STATUS: "",
        ACTION_FLAG: "U",
      };

      const result = await makeRequest(
        "POST",
        urls.setUserContactDtl,
        payload,
        config
      );

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        fetchCustomersUsers();
        handleAddCustUserMdl();
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const initialVal = {
    personNm: isEdit ? editData.PERSON_NM : "",
    designationValue: isEdit ? editData.DESIGNATION_ID : "",
    designationLabel: isEdit ? designationList.find((items) => items.TRAN_CD === editData.DESIGNATION_ID)?.DESIGNATION_NM : "",
    contactNo: isEdit ? editData.MOBILE_NO1 : "",
    emailId: isEdit ? editData.EMAIL_ID : "",
  };

  const validationSchema = Yup.object().shape({
    personNm: Yup.string()
      .required("Person name is required")
      .max(50, "Person name must not exceed 50 characters"),
    designationValue: Yup.string().required("Designation is required"),
    contactNo: Yup.string()
      .required("Contact no. is required")
      .min(10, "Contact no. must not exceed 10 digits")
      .max(10, "Contact no. must not exceed 10 digits"),
    emailId: Yup.string()
      .required("Email id is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Invalid email id address"
      )
  });

  return (
    <div>
      <Modal
        backdrop="static"
        keyboard={false}
        size="sm"
        show={isOpen}
        onHide={handleAddCustUserMdl}
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit" : "Add"} Contact Person</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={initialVal}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (isEdit) {
              updateCustomer(values);
            } else {
              addCustomer(values)
            }
          }}
        >
          {({ values, handleChange, handleBlur, setFieldValue, setFieldTouched }) => (
            <Form>
              <Modal.Body>
                <div className="form-group row">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-12 mb-3">
                        <TextField
                          label="Person Name"
                          name="personNm"
                          id="personNm"
                          required
                          tabIndex={2}
                          maxLength={30}
                          value={values.personNm}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage name="personNm" className='error-msg' component="div" />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col mb-3">
                        <SelectField
                          name="designation"
                          tabIndex={2}
                          options={[
                            { value: "", label: "Select Designation" },
                            ...designationList.map((items) => ({
                              value: items.TRAN_CD, label: items.DESIGNATION_NM
                            }))]}
                          required
                          placeholder="Designation"
                          value={values.designationValue !== "" && {
                            value: values.designationValue,
                            label: values.designationLabel
                          }}
                          onChange={(e) => {
                            setFieldValue("designationValue", e?.value);
                            setFieldValue("designationLabel", e?.label);
                          }}
                          onBlur={() => {
                            setFieldTouched("designationValue", true);
                          }}
                        />
                        <ErrorMessage name="designationValue" className='error-msg' component="div" />
                      </div>
                    </div>
                    <div className="row g-2">
                      <div className="col mb-0">
                        <TextField
                          label="Contact No."
                          name="contactNo"
                          id="contactNo"
                          required
                          tabIndex={3}
                          maxLength={10}
                          value={values.contactNo}
                          onChange={(e) => {
                            e.preventDefault();
                            const { value } = e.target;
                            const regex = /^[0-9]*[.,]?[0-9]*$/;
                            if (regex.test(value.toString())) {
                              setFieldValue("contactNo", value);
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage name="contactNo" className='error-msg' component="div" />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-lg-12 col-md-12 col-12 mb-3">
                        <TextField
                          label="Email Id"
                          type="email"
                          name="emailId"
                          id="emailId"
                          required
                          tabIndex={4}
                          maxLength={30}
                          value={values.emailId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <ErrorMessage name="emailId" className='error-msg' component="div" />
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer className="py-2">
                <Button
                  type="submit"
                  variant="primary"
                  className=" btn-sm">
                  Submit
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  className="btn-sm"
                  onClick={handleAddCustUserMdl}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default ClientcontactDtlAddModal;
